import { DailyTag } from "@/pages/human-resources/time-management/business/daily-tag/DailyTag.ts";
import type { DailyTagCategory } from "@/pages/human-resources/time-management/business/daily-tag/DailyTagCategory.ts";
import type { DailyTagDuration } from "@/pages/human-resources/time-management/business/daily-tag/DailyTagDuration.ts";
import type { DailyTagEquivalence } from "@/pages/human-resources/time-management/business/daily-tag/DailyTagEquivalence.ts";

export interface DailyTagOut {
  idTimeSlotCategory: string;
  category: string;
  domainId: number;
  siteId?: number;
  libelle: string;
  description?: string;
  couleur?: string;
  solo: boolean;
  valeur: number;
  obsolete: boolean;
  provided: boolean;
  equivalenceHoraireValeur: number;
  equivalenceHoraireType: string;
  equivalenceHoraireModify: boolean;
  nbRepas: number;
}

export function mapToDailyTag(out: DailyTagOut): DailyTag {
  return new DailyTag(
    out.idTimeSlotCategory,
    out.category as DailyTagCategory,
    out.domainId.toString(),
    out.siteId?.toString(),
    out.obsolete,
    mapEquivalence(out.equivalenceHoraireType),
    out.libelle,
    out.description ?? "",
    out.nbRepas,
    out.couleur,
    out.solo,
    out.equivalenceHoraireValeur,
    out.equivalenceHoraireModify,
    mapDuration(out.valeur),
  );
}

function mapEquivalence(out: string): DailyTagEquivalence {
  switch (out) {
    case "SIMPLE":
      return "FIXED";
    case "CONTRAT":
      return "CONTRACT";
    case "PLANNING_ET_CONTRAT":
      return "SCHEDULE_OR_CONTRACT";
    case "UNDEFINED":
      return "NONE";
    default:
      throw new Error(`Unexpected equivalence type ${out}`);
  }
}

function mapDuration(nbDays: number): DailyTagDuration {
  switch (nbDays) {
    case 1:
      return "FULL";
    case 0.5:
      return "HALF";
    case 0:
      return "NONE";
    default:
      throw new Error(`Unexpected day duration ${nbDays}`);
  }
}
